/* eslint-disable fp/no-mutation */
import { useState, useEffect, useRef, useCallback } from 'react'

let MAX_RETRIES = 3

export function useCdnImageRetry(imageUrl: string | null): {
  src: string | null
  onError: () => void
  isRetrying: boolean
  hasError: boolean
} {
  let [retryCount, setRetryCount] = useState(0)
  let [isRetrying, setIsRetrying] = useState(false)
  let [hasError, setHasError] = useState(false)
  let retryTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current)
    setRetryCount(0)
    setIsRetrying(false)
    setHasError(false)
  }, [imageUrl])

  useEffect(
    () => () => {
      if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current)
    },
    [],
  )

  let src =
    imageUrl == null
      ? null
      : retryCount > 0
        ? `${imageUrl}?retry=${retryCount}`
        : imageUrl

  let onError = useCallback(() => {
    setIsRetrying(true)
    if (retryCount < MAX_RETRIES) {
      retryTimeoutRef.current = setTimeout(
        () => {
          setIsRetrying(false)
          setRetryCount((c) => c + 1)
        },
        2000 * 2 ** retryCount,
      )
    } else {
      setIsRetrying(false)
      setHasError(true)
    }
  }, [retryCount])

  return { src, onError, isRetrying, hasError }
}
